import { FC } from "react";
import "./DirectoryPath.scss";

export const DirectoryPath: FC = () => {
  return <div className="directory-path">~</div>;
};
